// --------------------------------------------------------
// ENCAIXE VALIDACAO MODAL - EncaixeValidacaoModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { ModalContentContainer } from '../genericModal/GenericModal.styled';
import { H2, Text } from '../UI/generalLayout/Layout.styled';
import { ReactComponent as Exclamation } from '../../assets/imgs/exclamation.svg'
import styled from 'styled-components';
import { GenericSolidButton } from '../UI/buttons/Button.styled';
import Colors from '../../constants/Colors';
import moment from 'moment';
import { SchedulingService } from '../../core/http/service/SchedulingService';
import { useSelector } from 'react-redux';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ENCAIXE VALIDACAO MODAL INTERFACE
// --------------------------------------------------------

interface IEncaixeValidacaoModal {
    visible: boolean;
    onDesmarcarEncaixe: any;
    onEncaixe: any;
    agendamentoFuturo: any;
}

export const ButtonArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
`;

export const ModalContent = styled.div<{ isMobile?: boolean }>`
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 95vw;
  min-width: ${(props) => (props.isMobile ? "300px" : "560px")};
  min-height: ${(props) => (props.isMobile ? "350px" : "320px")};
  background-color: #ffffff;
`;

/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const EncaixeValidacaoModal = ({ visible, agendamentoFuturo, onDesmarcarEncaixe, onEncaixe }: IEncaixeValidacaoModal) => {
    // --------------------------------------------------------
    // ENCAIXE VALIDACAO MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    const { units } = useSelector((state:any)=> state.unit)
    const [unidadeDoAgendamento, setUnidadeDoAgendamento] = useState<any>(null)

    useEffect(()=>{
        const unidade = units.filter((u: any)=> { return u.id === agendamentoFuturo?.unidadeAtendimentoId})
        setUnidadeDoAgendamento(unidade[0]);
    }, [units, visible])

    const dia = moment.utc(agendamentoFuturo?.horario).format('DD/MM/YYYY');
    const horario = moment.utc(agendamentoFuturo?.horario).format('HH:mm');
    // --------------------------------------------------------
    const message = `Paciente possui agendamento para este tipo de atendimento no dia ${dia} às ${horario} na Unidade ${unidadeDoAgendamento?.nomeFantasia}. Como deseja prosseguir?`
    
    const desmarcarAgendamento = async ()=>{
        const service: SchedulingService<any> = new SchedulingService();
        await service.postInactiveByID(agendamentoFuturo.id);
    }
    
    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Modal open={visible}>
                <ModalContent isMobile={isMobile}>
                    <ModalContentContainer>
                        <Exclamation />
                        {isMobile ? <Text style={{ fontSize: 15 }}>{message}</Text> : <H2>{message}</H2>}
                        <ButtonArea>
                            <GenericSolidButton 
                                color={Colors.SPM600} 
                                style={{ marginBottom: 10 }}
                                onClick={()=>{ desmarcarAgendamento(); onDesmarcarEncaixe(); }}>
                                Desmarcar e fazer encaixe
                            </GenericSolidButton>
                            <GenericSolidButton 
                                color={Colors.SPM600}
                                onClick={onEncaixe}>
                                Fazer encaixe
                            </GenericSolidButton>
                        </ButtonArea>
                    </ModalContentContainer>
                </ModalContent>
            </Modal>
        </>
    )
    // --------------------------------------------------------
}

export default EncaixeValidacaoModal